/**
 * 智能售罄提示
 */
import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import {
  menuMobx,
} from 'restaurant'
import { decorationMobx } from '@mobxStore'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
}

const SoldoutBar: React.FC<IProps> = () => {
  const [slideStep, setSlideStep] = useState(0) // 动画步骤 0 准备 1 滑入 2 滑出
  const openSoldout = decorationMobx.mealDecorates?.openSoldout || 0
  let sildeTimer = null // 关闭弹层定时器
  const handleConfirm = () => {
    menuMobx.setIsOpenSoldout(true)
    handleCancel()
  }
  const handleCancel = () => {
    setSlideStep(2)
    setTimeout(() => {
      menuMobx.setCanOpenSoldout(false)
    }, 500)
  }
  useEffect(() => {
    if (slideStep === 0) {
      menuMobx.setCanOpenSoldout(true)
      setSlideStep(1)
      sildeTimer = setTimeout(() => {
        handleCancel()
      }, 15500)
    }
    return () => {
      handleCancel()
      clearTimeout(sildeTimer)
    }
  }, [])

  return (
    menuMobx.canOpenSoldout && openSoldout === 1 ? (
      <div
        className={classNames('menu-soldout-container', {
          'slidein': slideStep === 1,
          'slideout': slideStep === 2,
        })}
      >
        <span className='txt'>{i18n.t('menu.soldoutTip')}</span>
        <div className='soldout-btn' onClick={handleConfirm}>{i18n.t('menu.hideSoldout')}</div>
        <Icon name='close' onClick={handleCancel} />
      </div>
    ) : null
  )
}

export default observer(SoldoutBar)
